import './index.css';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
// Bootstrap icons
import "bootstrap-icons/font/bootstrap-icons.css";

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './App.css'

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
<React.StrictMode>
    <App  />
</React.StrictMode>
);